module.exports = __webpack_public_path__ + "static/ayeni-a154299f9dba400123f872d80c5275f2.jpg";